import React, { useState } from 'react';
import { Send, CheckCircle2 } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { submitContact } from '../lib/api';

export default function ContactForm() {
  const { t } = useLang();
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState({ loading: false, success: false, error: '' });

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: '' });
    try {
      await submitContact(form);
      setStatus({ loading: false, success: true, error: '' });
      setForm({ first_name: '', last_name: '', email: '', phone: '', message: '' });
      setTimeout(() => setStatus((s) => ({ ...s, success: false })), 4500);
    } catch (err) {
      setStatus({ loading: false, success: false, error: t.form.error });
    }
  };

  const inputCls = 'w-full bg-transparent border-b border-neutral-300 focus:border-black outline-none py-3 text-[15px] transition-colors placeholder:text-neutral-400';

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-[11px] tracking-[0.25em] text-neutral-500 mb-1">{t.form.first.toUpperCase()}</label>
          <input required name="first_name" value={form.first_name} onChange={onChange} className={inputCls} />
        </div>
        <div>
          <label className="block text-[11px] tracking-[0.25em] text-neutral-500 mb-1">{t.form.last.toUpperCase()}</label>
          <input required name="last_name" value={form.last_name} onChange={onChange} className={inputCls} />
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-[11px] tracking-[0.25em] text-neutral-500 mb-1">{t.form.email.toUpperCase()}</label>
          <input required type="email" name="email" value={form.email} onChange={onChange} className={inputCls} />
        </div>
        <div>
          <label className="block text-[11px] tracking-[0.25em] text-neutral-500 mb-1">{t.form.phone.toUpperCase()}</label>
          <input name="phone" value={form.phone} onChange={onChange} className={inputCls} />
        </div>
      </div>
      <div>
        <label className="block text-[11px] tracking-[0.25em] text-neutral-500 mb-1">{t.form.message.toUpperCase()}</label>
        <textarea required name="message" rows={4} value={form.message} onChange={onChange} className={`${inputCls} resize-none`} />
      </div>

      <div className="flex items-center justify-between pt-2">
        {status.success ? (
          <p className="flex items-center gap-2 text-sm text-emerald-700">
            <CheckCircle2 className="w-4 h-4" />
            {t.form.success}
          </p>
        ) : status.error ? (
          <p className="text-sm text-[#e11f3a]">{status.error}</p>
        ) : (
          <span />
        )}
        <button
          type="submit"
          disabled={status.loading}
          className="inline-flex items-center gap-2 bg-black text-white px-8 py-3 text-sm tracking-[0.15em] hover:bg-[#e11f3a] transition-colors disabled:opacity-60"
        >
          {status.loading ? '...' : t.form.submit}
          <Send className="w-4 h-4" />
        </button>
      </div>
    </form>
  );
}
